import FieldPopover from "../../../fields3/generic/popover/popover"
import FieldEstimate_Popover from "./components/popover/popover"
import FieldEstimate_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldEstimate_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config"
import {GROUP_ESTIMATE} from "../../../gd/const/fields/field2-groups"
import FieldEstimate_View from "./render/view"
import normalizeNumber from "../../import/normalize/normalize-number"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldTaskEstimate_ConditionForm from "./render/condition/condition"
import {SortDirection} from "../../../data-structures/sort"
import AggregateNumber from "../../../fields/aggregate/aggregate-number"
import AggregateTime from "../../../fields/system/components/aggregate-time"
import FieldEstimate_ViewSmall from "./render/view-small"
import FieldEstimate_InlineValueEmpty from "./components/inline-edit/value-empty"
import FieldEstimate_Editable from "./render/editable/editable"
import {FieldFilterType} from "../../proto/types"
import {FIELD_CONDITIONS_NUMBER, FieldNumber_hours_filterFunc} from "../../conditions/number"
import {AggregateFunctionType} from "../../../data-structures/aggregators/types"
import FieldEstimate_TableCellCalculated from "./render/table/table-cell"
import FieldEstimate_AggregateCell from "./render/aggregate/aggregate-cell"
import FieldEstimate_BoardAggregate from "./render/aggregate/board-aggregate"
import FieldEstimate_QuickFilterView from "./render/quick-filter-view"

export default class FieldEstimate extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Estimate";
        this.filterType         = FieldFilterType.NUMBER;
        this.typeGroup          = GROUP_ESTIMATE
        this.typeDescription    = "Estimate selector"
        this.icon               = 'i5-time-estimate';

        this.isSearchable       = false
        this.isFilterAvailable  = true

        this.conditionTypes     = FIELD_CONDITIONS_NUMBER

        this.clearButton                            = _.get(config,'clearButton',true);

        this.hasCalculatedValues                    = true

        this.components.PopoverMenu                 = FieldEstimate_Popover
        this.components.FormValueNotEmpty           = FieldEstimate_FormValueNotEmpty


        this.components.InlineValueEmpty            = FieldEstimate_InlineValueEmpty
        this.components.InlineValueNotEmpty         = FieldEstimate_InlineValueNotEmpty

        this.renderComponents.view                  = FieldEstimate_View
        this.renderComponents.viewSmall             = FieldEstimate_ViewSmall
        this.renderComponents.editable              = FieldEstimate_Editable

        this.renderComponents.conditionForm         = FieldTaskEstimate_ConditionForm
        this.renderComponents.filterForm            = FieldTaskEstimate_ConditionForm

        this.renderComponents.tableCell             = FieldEstimate_TableCellCalculated
        this.renderComponents.tableCellCalculated   = FieldEstimate_TableCellCalculated
        this.renderComponents.aggregateCell         = FieldEstimate_AggregateCell
        this.renderComponents.boardAggregate        = FieldEstimate_BoardAggregate
        this.renderComponents.quickFilterView       = FieldEstimate_QuickFilterView

        this.filterFunc                             = FieldNumber_hours_filterFunc

    }

    getDisplayValue(value: any): any {
        return gd.utils.minutesHumanize(value)
    }

    groupValue(value: any) {
        if (!value || value === 'null') return null
        return typeof value === 'string' ? parseInt(value) : value
    }

    groupLabel(value: any): string {
        const groupValue = this.groupValue(value)
        if (_.isNil(groupValue) || _.isNaN(groupValue)) return 'Not set'
        return gd.utils.minutesHumanize(groupValue)
    }

    sortValue(value: any) {
        return value ? (typeof value === 'string' ? parseInt(value) : value) : 0
    }


    // Custom Methods

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeNumber(value)
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [(listItem:any) => this.getViewValue(listItem.item) || 0],
            directions  : [sort]
        }
    }

    getAggregateClass() {
        return AggregateNumber
    }

    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    get AggregateComponent() {
        return AggregateTime.bind(null, this.getAggregateOptions())
    }

    // Formula compatability
    getValueType() {
        return gd.const.fields.valueType.FLOAT
    }

    getFormulaValue(model:any) {

        const minutes = this.getViewValue(model)
        if (!minutes) return 0

        return gd.utils.Time.roundHours(minutes)
    }

    countValue(model: any): number {
        return model[this.fieldId] || 0
    }
}
